import React from 'react';

import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Tag, { TagType } from '@amzn/meridian/tag/tag';
import Text from '@amzn/meridian/text';

import { Link } from 'react-router-dom';
import { RateCardStatus } from 'src/constants';
import { PHONE_TOOL_URL } from 'src/constants/phoneTool';
import { RATE_CARD_STATUS_TAG_THEMES } from 'src/constants/rateCards';
import { IRateCardHeaderValues } from 'src/types/IRateCard';
import { getRateCardStatus } from 'src/util/RateCards';
import { convertTimestampToYYYYMMDDUTCTimeZone } from 'src/util/dateTimeUtil';

import './RateCardHeader.scss';

interface IRateCardHeaderProps {
    rateCardHeaderValues: IRateCardHeaderValues;
    children?: JSX.Element | false;
}

export const getUserElement = (user: string, isGridCellRenderer = false): JSX.Element => {
    // Wrap text in Text component, unless it is in the grid

    if (
        [user === 'init', user === 'data_sync_python_tool', user === 'Hydra Integ Test', user.startsWith('mcm')].some(
            (condition) => condition === true
        )
    ) {
        return isGridCellRenderer ? <>{user}</> : <Text>{user}</Text>;
    }

    return (
        <Link
            style={{ textDecoration: 'none' }}
            to={{
                pathname: `${PHONE_TOOL_URL}${user}`
            }}
            target="_blank"
        >
            {isGridCellRenderer ? <div className="link-text">@{user}</div> : <Text className="link-text">@{user}</Text>}
        </Link>
    );
};

export const RateCardHeader = ({ rateCardHeaderValues, children }: IRateCardHeaderProps) => {
    return (
        <Box type="fill" spacingInset="400">
            <Column spacing="200">
                <Row alignmentHorizontal="justify">
                    <Text type="h400" transform="uppercase">
                        {rateCardHeaderValues.contractName}
                    </Text>
                    {children}
                </Row>
                <Text>{rateCardHeaderValues.description}</Text>
                <Column spacingInset="none none 400 none">
                    <Row>
                        <Tag type={RATE_CARD_STATUS_TAG_THEMES[getRateCardStatus(rateCardHeaderValues)] as TagType}>
                            {getRateCardStatus(rateCardHeaderValues) || RateCardStatus.Draft}
                        </Tag>
                        <Text>
                            {rateCardHeaderValues.creationDate
                                ? 'Created ' +
                                  convertTimestampToYYYYMMDDUTCTimeZone(new Date(rateCardHeaderValues.creationDate))
                                : ''}
                        </Text>
                        {rateCardHeaderValues.createdBy && getUserElement(rateCardHeaderValues.createdBy)}
                        {rateCardHeaderValues.changedDate && (
                            <>
                                <Text>
                                    {rateCardHeaderValues.changedDate
                                        ? 'Last updated ' +
                                          convertTimestampToYYYYMMDDUTCTimeZone(
                                              new Date(rateCardHeaderValues.changedDate)
                                          )
                                        : ''}
                                </Text>
                                {rateCardHeaderValues.changedBy && getUserElement(rateCardHeaderValues.changedBy)}
                            </>
                        )}
                    </Row>
                </Column>
            </Column>
        </Box>
    );
};
